import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import {
  FILE_SIZE_MB_DIVISOR,
  MAX_FILE_SIZE,
  SCALING_BUFFER,
  MIN_IMAGE_WIDTH,
  MIN_IMAGE_HEIGHT,
} from '../constants/size';

export function getLocalFileSize(file) {
  return _get(file, 'size', 0);
}

export function getFormattedLocalFileSize(file) {
  const size = getLocalFileSize(file);
  if (!size) return '';

  return `${(size / FILE_SIZE_MB_DIVISOR).toFixed(2)} MB`;
}

export function exceedsMaxFileSize(file) {
  if (_isEmpty(file)) {
    return false;
  }

  return getLocalFileSize(file) > MAX_FILE_SIZE;
}

export function getScaleFactor(imageSize, maxAllowedSize = MAX_FILE_SIZE) {
  return Math.sqrt(maxAllowedSize / imageSize - SCALING_BUFFER);
}

export async function getImageDimensions(file) {
  if (_isEmpty(file)) {
    return Promise.resolve(null);
  }

  const fileObj = _get(file, 'file', file);

  // Only process image files
  if (!fileObj.type?.startsWith('image/')) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      });
    };
    img.onerror = () => {
      resolve(null);
    };
    img.src = URL.createObjectURL(fileObj);
  });
}

export async function belowMinImageDimensions(file) {
  const dimensions = await getImageDimensions(file);

  if (!dimensions) {
    return false;
  }

  const belowMinWidth = dimensions.width < MIN_IMAGE_WIDTH;
  const belowMinHeight = dimensions.height < MIN_IMAGE_HEIGHT;

  return belowMinWidth || belowMinHeight;
}
